import { render, staticRenderFns } from "./uploadfile.vue?vue&type=template&id=7bf03c68&scoped=true"
import script from "./uploadfile.vue?vue&type=script&lang=js"
export * from "./uploadfile.vue?vue&type=script&lang=js"
import style0 from "./uploadfile.vue?vue&type=style&index=0&id=7bf03c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf03c68",
  null
  
)

export default component.exports